import linkifyHtml from 'linkify-html';
import { useCallback } from 'react';
import sanitizeHtml from 'sanitize-html';

export const useSanitizeHtml = () => {
  const sanitizeDisplayHtml = useCallback((html: string): string => {
    const linked = linkifyHtml(html || '', {
      defaultProtocol: 'https',
      attributes: { target: '_blank', rel: 'noopener noreferrer' },
    });

    return sanitizeHtml(linked, {
      allowedTags: ['p', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'br', 'span', 'a'],
      allowedAttributes: {
        a: ['href', 'target', 'rel'],
        span: ['class'],
        li: ['data-list'],
      },
    });
  }, []);

  return { sanitizeDisplayHtml };
};
